import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { provideEffects } from '@ngrx/effects';

import { TranslocoEffects } from './+state/transloco.effects';
import { InternationalizationService } from './services/internationalization.service';
import { TranslocoRootModule } from './transloco-root.module';

@NgModule({
  imports: [CommonModule, TranslocoRootModule],
  providers: [provideEffects(TranslocoEffects), InternationalizationService],
  exports: [TranslocoRootModule],
})
export class SharedTranslationModule {}
